import { updateAppUrl } from 'lib/url/route'
import { objectToQueryString } from 'lib/helpers'
import url from 'url'
import { DEFAULT_APP, DEFAULT_URL } from './constants'
const { APP_ENV } = process.env
const DOMAIN =
  APP_ENV === 'local' || APP_ENV === 'qa'
    ? 'https://www.qa.saatchiart.com'
    : 'https://www.saatchiart.com'

export const numberWithCommas = (value: string): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// function to replace long string with ... based on string length value
export const displayEllipticalString = (text: string, maxLength: number) => {
  if (text.length <= maxLength) {
    return text
  }
  return `${text.slice(0, maxLength)}...`
}

export const updateDataLayer = (gtmEventData: Record<string, any>): void => {
  window && window.dataLayer && window.dataLayer.push({ ...gtmEventData })
}

type Params = {
  section?: string
  userName?: string
  userId?: string
}

export const createLocationUrl = ({ section, userId, userName }: Params, queryString): string => {
  if (section !== 'artworks' && userName) {
    return `/${userName}`
  }
  return `${DEFAULT_URL}${section ? `/${section}` : ''}/${userId}${queryString ? queryString : ''}`
}

export const updateProfileUrl = (params: Params, queryString?: string): void => {
  const app = `${DEFAULT_APP}?${objectToQueryString(params)}`
  const href = createLocationUrl(params, queryString)
  updateAppUrl({
    app,
    href,
  })
}

// We need a way to pull SPECIAL Query Params for ALGOLIA
// Ex: hitsPerPage, page, sort
export const getPageParamsQuery = (href: string = ''): Record<string, any> => {
  const { query } = url.parse(href, true)
  const { hitsPerPage, page } = query || {}
  return {
    hitsPerPage,
    page,
  }
}

// We need a way to pull SPECIAL Query Params for ALGOLIA
// Ex: hitsPerPage, page
export const getAlgoliaQueryParams = (href: string = ''): Record<string, any> => {
  const { query } = url.parse(href, true)
  const { hitsPerPage, page } = query || {}
  return {
    hitsPerPage: hitsPerPage || 100,
    page,
  }
}

export const updateArtworksUrl = (href: string): void => {
  updateAppUrl({
    app: DEFAULT_APP,
    href,
  })
}

export const updateImagePathBasedOnHostName = (urlString) => {
  try {
    const url = new URL(urlString)
    // qa user profiles have different cloudfront distribution names eg: https://d3p16shm4e5pue.cloudfront.net/*
    // these now point to https://www.qa.saatchiart.com/saatchi-dev-s3/*
    //some user profiles are snapshot from prod, so they all have prod cloudfront urls
    // eg: https://d38we5ntdyxyje.cloudfront.net/*
    // these now point to https://www.saatchiart.com/saatchi-s3/*
    // we need to do this check to construct the correct URL
    const prodCloudFrontUrl = 'd38we5ntdyxyje.cloudfront.net'
    if (url.hostname === prodCloudFrontUrl) {
      return `${DOMAIN}/saatchi-s3` + url.pathname + url.search + url.hash
    }
    return `${DOMAIN}/saatchi-dev-s3` + url.pathname + url.search + url.hash
  } catch (error) {
    // If the URL is not absolute, return the input as it is
    return urlString
  }
}

export const handleReadMoreClick = () => {
  const element = document.getElementById('about-section')
  return element?.scrollIntoView({
    behavior: 'smooth',
  })
}

export const hasAnyValue = (obj) => {
  return Object.values(obj).some((value) => value !== undefined && value !== null && value !== '')
}
